import { useState } from "react";

/**
 * Retains the argument value. If the argument value is null, it keeps the stored value.
 * This is useful for retaining the value of a dialog or modal open state when the component is unmounted.
 */
export const useStickyValue = <T>(value: T | null) => {
  const [stickyValue, setStickyValue] = useState(value);
  if (value !== null && value !== stickyValue) setStickyValue(value);
  return value ?? stickyValue;
};
